import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Link } from "react-router-dom";
import logobottom from "../img/logobottom.svg";

const useStyles = makeStyles((theme) => ({
  logo: { width: "70px" },
  footerMain: {
    backgroundColor: "#4e4d5e",
    padding: "10px 0px",
    zIndex: "3",
    position: "relative",
    color: "white",
  },
  newhelplink: {
    textDecoration: "none",
    color: "rgb(255,255,255,0.7)",
    fontSize: "14px",
    marginTop: "4px",
    "&:hover": {
      color: "white",
    },
  },
}));

function SwiftFoot() {
  const classes = useStyles();
  return (
    <>
      <Grid
        className={classes.footerMain}
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <img className={classes.logo} src={logobottom} alt="logo"></img>
        <Typography variant="subtitle1">Swiftgrade Help Center</Typography>
        <Link className={classes.newhelplink} to="/">
          Try our new help center →
        </Link>
      </Grid>
    </>
  );
}

export default SwiftFoot;
